<img class="shrink-0 h-full w-full" pTooltip="{{ tooltip() }}" [src]="`https://api.dicebear.com/9.x/initials/svg?seed=${initials()}`" />